<template>
  <!-- 压力-上传中断报警列表 -->
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6" :sm="12">
              <a-form-item label="水表名称">
                <a-input v-model="query.deviceName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="水表编号">
                <a-input v-model="query.deviceNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="12">
              <a-form-item label="报警日期">
                <a-date-picker placeholder="请选择" :allowClear="false" v-model="query.alarmDate" format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD" :open="open" @openChange="openChange" @panelChange="panelChange" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="处理状态">
                <a-select placeholder="请选择处理状态" v-model="query.processingStatus" allow-clear>
                  <a-select-option :value="1"> 未处理 </a-select-option>
                  <a-select-option :value="2"> 已处理 </a-select-option>
                  <a-select-option :value="3"> 已忽略 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" style="display: flex">
              <a-form-item>
                <a-button type="primary" @click="queryList">查询</a-button>
              </a-form-item>
              <a-form-item style="margin-left: 12px">
                <a-button @click="resetList">重置</a-button>
              </a-form-item>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
             
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table rowKey="id" :scroll="{ x: 1800 }" :columns="columns" :data-source="list"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }" :pagination="pagination"
        @change="pageChange" bordered>
        <span slot="type" slot-scope="text">
          <span v-if="text == 0">报警</span>
          <span v-else>故障</span>
        </span>
        <span slot="processingStatus" slot-scope="text">
          <a-tag color="rgb(255, 99, 71)" v-if="text == 1"> 未处理 </a-tag>
          <a-tag color="rgb(50, 205, 50)" v-else-if="text == 2"> 已处理 </a-tag>
          <a-tag color="#1890ff" v-else> 已忽略 </a-tag>
        </span>
        <span slot="alarmType" slot-scope="text">
          <a-tag color="rgb(255, 0, 0)"> 数据中断报警 </a-tag>
        </span>
        <span slot="malfunctionLevel" slot-scope="text">
          <a-tag color="rgb(255, 0, 0)" v-if="text == 2"> 报警 </a-tag>
          <a-tag color="rgb(255, 165, 0)" v-else> 预警 </a-tag>
        </span>
        <span slot="Operation" slot-scope="text, record">
          <a @click="PublishTask(record)" :disabled="record.processingStatus !== 1">处理</a>
          <a style="margin-left: 12px" :disabled="record.processingStatus !== 1" @click="LoseSightOf(record.id)">忽略</a>
        </span>
      </a-table>
      <task-modal ref="TaskModal" @handleOk="update"></task-modal>
      <a-modal title="处理报警" okText="处理" width="50%" :visible="showdeal" @ok="handleDealOk" @cancel="handleDealCancel">
        <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="处理人">
            <a-input v-decorator="['disposeName', { rules: [{ required: true, message: '请输入处理人!' }] }]" />
          </a-form-item>
          <a-form-item label="报警描述">
            <a-input v-decorator="['alarmContent', { rules: [{ required: true, message: '请输入报警描述!' }] }]" />
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import TaskModal from '@/views/maintenance/TaskManagement/modules/TaskModal'

export default {
  components: {
    TaskModal
  },
  mixins: [mixinViewModule],
  data() {
    return {
      id: '',
      level: '选择报警级别',
      showdeal: false,
      queryUrl: '/pipe-network/data_interruption_alarm_list/page',
      exportDataUrl: 'pipe-network/data_interruption_alarm_list/export',
      deleteUrl: '/pipe-network/data_interruption_alarm_list',
      visible: false,
      confirmLoading: false,
      list: [],
      query: {
        deviceName: '',
        alarmDate: '',
        alarmType: 3,        
        deviceNo: '',
        processingStatus: '',
        disposeName: '',
      },
      zoneTreeData: [],
      open: false,
      form: this.$form.createForm(this, { name: 'coordinated' }),
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 70,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '水表编号',
          dataIndex: 'deviceNo',
          align: 'center'
        },
        {
          title: '水表名称',
          dataIndex: 'deviceName',
          align: 'center'
        },
        {
          title: '报警时间',
          dataIndex: 'alarmDate',
          align: 'center'
        },
        {
          title: '报警说明',
          dataIndex: 'description',
          align: 'center',
          width: 200,
          ellipsis: true,
        },
        {
          title: '报警类型',
          dataIndex: 'alarmType',
          align: 'center',
          scopedSlots: { customRender: 'alarmType' }
        },
        {
          title: '报警状态',
          dataIndex: 'alarmLevel',
          align: 'center',
          scopedSlots: { customRender: 'malfunctionLevel' }
        },
        {
          title: '处理状态',
          dataIndex: 'processingStatus',
          align: 'center',
          scopedSlots: { customRender: 'processingStatus' }
        },
        {
          title: '处理人',
          dataIndex: 'disposeName',
          align: 'center'
        },
        {
          title: '处理时间',
          dataIndex: 'disposeTime',
          align: 'center'
        },
        {
          title: '操作',
          width: 130,
          dataIndex: 'id',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'Operation' }
        }
      ],
      treeDefaultExpandedKeys: [],
    }
  },
  computed: {
    title() {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser() {
      return this.$store.getters.userInfo
    },
    token() {
      return this.$store.getters.token
    }
  },
  created() {
    this.getZoneData()
  },
  watch: {
    zoneTreeData(val) {
      this.chuli(val)
    }
  },
  methods: {
    panelChange(value) {
      this.query.alarmDate = value
      this.open = false
    },
    openChange(status) {
      if (status) {
        this.open = true
      } else {
        this.open = false
        this.queryList(false)
      }
    },
    chuli(n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.children = this.chuli(item.children)
          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    PublishTask(record) {
      this.currentId = record.id
      this.$refs.TaskModal.edit(record)
    },
    update() {
      const data = {
        id: this.currentId,
        processingStatus: 2
      }
      this.$http.put('/pipe-network/data_interruption_alarm_list/handling', data).then(({ data }) => {
        this.queryList()
      })
    },
    LoseSightOf(id) {
      const params = {
        id: id,
        processingStatus: 3
      }
      this.$confirm({
        title: '忽略',
        content: `您确定要忽略此条数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/data_interruption_alarm_list/update', params).then((res) => {
            this.queryList()
            this.$message.success(`忽略此条数据成功！`)
          })
        }
      })
    },
    getZoneData() {
      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    resetList() {
      this.query = {
        alarmDate: '',
        alarmType: '3',
        deviceNo: '',
        processingStatus: '',
        deviceName: '',
        disposeName: '',
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    handleChangeleve(e) {
      this.query.disposeResult = e
    },
    handleChange(e) {
      const params = { id: this.id, malfunctionLevel: e }
      const header = {
        'Content-Type': 'application/json',
        Authorization: this.token
      }
      this.$http({
        url: this.modifyUrl,
        data: params,
        headers: header,
        method: 'put'
      }).then((data) => {
        this.queryList()
        this.visible = false
        this.level = '选择报警级别'
        this.$message.success('标记成功')
      })
    },
    handleSelectChange(value) {
      this.form.setFieldsValue({ processingStatus: value })
    },
    handleDealSelectChange(value) {
      this.form.setFieldsValue({
        disposeResult: value
      })
    },
    Deal(id) {
      this.id = id
      this.showdeal = true
    },
    addOrUpdateHandle(id) {
      this.id = id
      this.showModal()
    },
    showModal() {
      this.visible = true
    },
    handleDealOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const year = new Date().getFullYear()
          let month = new Date().getMonth() + 1
          month = month < 10 ? '0' + month : month
          let day = new Date().getDate()
          day = day < 10 ? '0' + day : day
          let hour = new Date().getHours()
          hour = hour < 10 ? '0' + hour : hour
          let seconds = new Date().getSeconds()
          seconds = seconds < 10 ? '0' + seconds : seconds
          let minutes = new Date().getMinutes()
          minutes = minutes < 10 ? '0' + minutes : minutes
          const now = year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
          const params = {
            id: this.id,
            disposeName: values.disposeName,
            alarmContent: values.alarmContent,
            processingStatus: 2,
            disposeTime: now
          }
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token
          }
          this.$http({
            url: this.modifyUrl,
            data: params,
            headers: header,
            method: 'put'
          }).then((data) => {
            this.queryList()
            this.showdeal = false
            this.form.resetFields()
            this.$message.success('处理成功')
          })
        }
      })
    },
    handleDealCancel() {
      this.showdeal = false
    },
    handleOk() {
      this.visible = false
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
</style>
